import React from 'react'
import AppLayout from '../layouts/AppLayout';
import HomePageContent from '../components/UserComponents/Homepage/HomePageContent'


export default function HomePage() {
    return (
        <AppLayout>
            <HomePageContent/>
        </AppLayout>
    )
}
